import {
  SET_REQUEST_ID,
  SET_MASKED_DATA,
  SET_FORGOT_PROFILE,
  SET_FORGOT_STEP,
  SET_REQUEST_TOKEN,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  requestId: null,
  maskedData: {},
  forgotProfile: {},
  forgotStep: null,
  requestToken: null,
}

function setRequestId(state, action) {
  return {
    ...state,
    requestId: action.payload.requestId,
  }
}

function setMaskedData(state, action) {
  return {
    ...state,
    maskedData: action.payload.maskedData,
  }
}

function setForgotProfile(state, action) {
  return {
    ...state,
    forgotProfile: action.payload.forgotProfile,
  }
}

function setForgotStep(state, action) {
  return {
    ...state,
    forgotStep: action.payload.forgotStep,
  }
}

function setRequestToken(state, action) {
  return {
    ...state,
    requestToken: action.payload.requestToken,
  }
}
// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_REQUEST_ID:
      return setRequestId(state, action)
    case SET_MASKED_DATA:
      return setMaskedData(state, action)
    case SET_FORGOT_PROFILE:
      return setForgotProfile(state, action)
    case SET_FORGOT_STEP:
      return setForgotStep(state, action)
    case SET_REQUEST_TOKEN:
      return setRequestToken(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
